export enum PriorVetCareStatusName {
  YES = 'YES',
  NO = 'NO',
  UNKNOWN = 'UNKNOWN',
}

export enum ConsentStatusName {
  GRANTED = 'GRANTED',
  DENIED = 'DENIED',
  DEFERRED = 'DEFERRED',
}
